import { Deviation } from '../../../models/Deviation';
import { PreferredEmployee } from '../../../models/Interval';
import { VehicleFuelType, VehicleGearbox } from '../../../types/vehicleTypes';

export const initialVehicleState = {
  regNumber: '',
  brand: '',
  model: '',
  yearModel: '',
  dateOfUse: '',
  consumption: '',
  fuelType: VehicleFuelType.Gasoline,
  gearbox: VehicleGearbox.Manual,
  defaultDrivers: [] as PreferredEmployee[],
  deviations: [] as Deviation[],
};

export const fuelTypeData = [
  {
    title: 'Bensin',
    value: VehicleFuelType.Gasoline,
  },
  {
    title: 'Diesel',
    value: VehicleFuelType.Diesel,
  },
  {
    title: 'El',
    value: VehicleFuelType.Electric,
  },
  {
    title: 'Hybrid',
    value: VehicleFuelType.Hybrid,
  },
];

export const gearboxData = [
  {
    title: 'Manuell',
    value: VehicleGearbox.Manual,
  },
  {
    title: 'Automat',
    value: VehicleGearbox.Automatic,
  },
];

export const vehicleNames = [
  'Alfa Romeo',
  'Alpine',
  'Audi',
  'BMW',
  'BYD',
  'Cadillac',
  'Citroën',
  'Cupra',
  'Dacia',
  'Defender',
  'Discovery',
  'DS',
  'Fiat',
  'Ford',
  'Honda',
  'Hongqi',
  'Hyundai',
  'INEOS',
  'Jaguar',
  'Jeep',
  'KGM',
  'KIA',
  'Lexus',
  'Lotus',
  'Lynk & Co',
  'Mazda',
  'Mercedes-Benz',
  'MG',
  'Mini',
  'Mitsubishi',
  'NIO',
  'Nissan',
  'Opel',
  'ORA',
  'Peugeot',
  'Polestar',
  'Porsche',
  'Range Rover',
  'Renault',
  'Seat',
  'Skoda',
  'Smart',
  'Subaru',
  'Suzuki',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
  'WEY',
  'Xpeng',
  'Zeekr',
];
